// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentType } from "src/app/models/Enums";

export const environment = {
  // common properties across all environments ================
  brandTitleAtlasCopco: "Atlas Copco", // for login greeting text and also used for getting countries for company controller
  brandTitleDesoutter: "Desoutter", // for login greeting text and also used for getting countries for company controller
  brandWebTitleAtlasCopco: "WhereIsMyTool",
  brandWebTitleDesoutter: "TMSS",
  brandLinkAtlasCopco: "https://www.atlascopco.com", // for login greeting text
  brandLinkDesoutter: "https://www.desouttertools.com/", // for login greeting text
  brandLogoAtlasCopco: "assets/img/atlas-copco-logo.svg",
  brandLogoDesoutter: "assets/img/desoutter-logo.jpeg",
  brandBannerAtlasCopco: "assets/img/atlas-copco-banner.png",
  brandBannerDesoutter: "assets/img/desoutter-banner.png",
  brandFaviconAtlasCopco: "assets/img/favicon-ac-group.ico",
  brandFaviconDesoutter: "assets/img/favicon-desoutter.ico",
  atlasCopcoServAidUrl: "https://servaid.atlascopco.com/AssertWeb/",
  desoutterServAidUrl: "https://service-link.desouttertools.com/AssertWeb/",
  atlasCopcoTrainingYoutubeLink:
    "https://www.youtube.com/watch?v=aS0M8hlvnxY&list=PLfnmBy8Tm1efnwHbc_Jdps7MjQN8saV_X",
  desoutterTrainingYoutubeLink:
    "https://www.youtube.com/playlist?list=PLRHVLMF3gd-9lkdbODrbO04Gcw_fIkrz5",
  appVersion: "2.6.6",
  tenant: "OneVirtualOffice.onmicrosoft.com",
  azureNewUserCreationFormUrl:
    "https://ac-app-p-app-10000406.azurewebsites.net/AppControl/Easy/Detail/00000000-0000-0000-0000-000000000000?Admin=False",
  // end of common properties =========================

  // environment specific properties
  production: false,
  msalConfig: {
    auth: {
      clientId: "1c95b6de-996d-4af1-bf4a-50015a91c274",
      authority: "https://login.microsoftonline.com/OneVirtualOffice.onmicrosoft.com",
      redirectUri: "/auth",
      postLogoutRedirectUri: "/login",
    },
  },
  apiConfig: {
    uri: "https://stg-api.whereismytool.com",
    scopes: ["api://02cc4ff8-d2b0-463f-a2fa-81709af59dae/access_as_user_wimt_client"],
  },
  desoutterDomains: ["stgcp.whereismytool.com"],

  env: EnvironmentType.Staging,
  appInsights: {
    disabled: false,
    connectionString:
      "InstrumentationKey=ac105f90-674a-443a-a015-10d02fac4121;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/",
  },
  techCover: {
    qcmPortalUrl: "https://itba-crm--acsrvstg.sandbox.my.site.com/Customers/s/",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
